export default {
  data() {
    return {
      // ta集合
      menuList: [
        { id: 1, name: '用户管理', url: '/system-settings/user-manage/user-list'},
        { id: 2, name: '投资人管理', url: '/system-settings/user-manage/invenstment-list'}
      ],
    }
  },
  created() {
  },
  methods: {
    toUrl(v) {
      this.$router.push({
        path: v,
      });
    },
  }
}